import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeDuplicatedFromCart } from '../../api/cart/remove-duplicated-from-cart';
import syncCartCache from './sync-cart-cache';

const useRemoveDuplicatedFromCart = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: removeDuplicatedFromCart,
        onSuccess: (cart) => syncCartCache(queryClient, cart)
    });
};

export default useRemoveDuplicatedFromCart;
